// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JigDU","expireSoon":"styles_expireSoon__12jCv"};